/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { getAltCode } from '@utils/alternativeCode';
import { Column } from '../tracking-list';

export interface ColumnTitleProps
  extends Pick<ColumnCommonProps, 'question' | 'alternativeCode' | 'preferredAltCodes'> {
  handleGoToQuestion?: () => void;
  tooltip?: string;
}

export const ColumnTitle = (props: ColumnTitleProps) => {
  const { question, alternativeCode, preferredAltCodes, tooltip } = props;
  const utr = question.universalTracker;
  const fullTitle = utr.getName(getAltCode(utr, alternativeCode, preferredAltCodes));
  const displayTooltip = tooltip ?? fullTitle;

  return (
    <Column className='pl-2' fill truncateTwoline tooltip={displayTooltip} onClick={props.handleGoToQuestion}>
      {fullTitle}
    </Column>
  );
}
